export default "__VITE_ASSET__ec90661b__"